export function RotateLeftIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14 3a.5.5 0 00-.8-.4l-2.667 2a.5.5 0 000 .8l2.667 2A.5.5 0 0014 7v-.987c3.216.562 5.491 3.627 5.011 6.84a1 1 0 101.978.295C21.645 8.762 18.501 4.662 14.148 4.01c-.05-.007-.1-.011-.148-.011V3zm3 9a3 3 0 00-3-3h-8a3 3 0 00-3 3v6a3 3 0 003 3h8a3 3 0 003-3v-6zm-3-1a1 1 0 011 1v6a1 1 0 01-1 1h-8a1 1 0 01-1-1v-6a1 1 0 011-1h8z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
